module.exports = __webpack_public_path__ + "img/new-guide-00-4.c4daee84.png";